// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let FragmentErrorBoundary = require("../ErrorHandling/FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let CondoPropertyAttributes = require("./CondoPropertyAttributes.bs.js");
let UnselectedUnionMemberError = require("../ErrorHandling/UnselectedUnionMemberError.bs.js");
let SingleFamilyPropertyAttributes = require("./SingleFamilyPropertyAttributes.bs.js");
let RentalPropertyAttributes_property_graphql = require("../../../__generated__/RentalPropertyAttributes_property_graphql.bs.js");

let convertFragment = RentalPropertyAttributes_property_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, RentalPropertyAttributes_property_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(RentalPropertyAttributes_property_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, RentalPropertyAttributes_property_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(RentalPropertyAttributes_property_graphql.node, convertFragment, fRef);
}

let PropertyFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function RentalPropertyAttributes$WithoutErrorBoundary(props) {
  let __displayPropertyType = props.displayPropertyType;
  let size = props.size;
  let displayPropertyType = __displayPropertyType !== undefined ? __displayPropertyType : true;
  let property = RescriptRelay_Fragment.useFragment(RentalPropertyAttributes_property_graphql.node, convertFragment, props.property);
  let propertyType = property.propertyType;
  switch (propertyType.__typename) {
    case "CondoProperty" :
      return JsxRuntime.jsx(CondoPropertyAttributes.make, {
        propertyType: propertyType.fragmentRefs,
        size: size,
        displayPropertyType: displayPropertyType
      });
    case "SingleFamilyProperty" :
      return JsxRuntime.jsx(SingleFamilyPropertyAttributes.make, {
        propertyType: propertyType.fragmentRefs,
        size: size,
        displayPropertyType: displayPropertyType
      });
    case "__unselected" :
      return UnselectedUnionMemberError.raise(`Unselected propperty type ` + propertyType._0);
  }
}

let WithoutErrorBoundary = {
  make: RentalPropertyAttributes$WithoutErrorBoundary
};

function RentalPropertyAttributes(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "property attributes",
    children: JsxRuntime.jsx(RentalPropertyAttributes$WithoutErrorBoundary, {
      property: props.property,
      size: props.size,
      displayPropertyType: props.displayPropertyType
    })
  });
}

let make = RentalPropertyAttributes;

exports.PropertyFragment = PropertyFragment;
exports.WithoutErrorBoundary = WithoutErrorBoundary;
exports.make = make;
/* react/jsx-runtime Not a pure module */
